<template>
  <v-snackbar
    v-if="title || message"
    v-model="shown"
    app
    :color="messageType"
    elevation="16"
    max-width="600"
    min-width="300"
    outlined
    rounded="lg"
    :timeout="customEvents.length ? -1 : 9999999999"
    top
    transition="scroll-y-reverse-transition"
    :vertical="!!customEvents"
  >
    <template v-slot:default>
      <div class="d-flex" :class="!!customEvents && 'pe-2'">
        <div>
          <v-icon class="mt-1 me-4" :color="messageType">{{ messageIcon }}</v-icon>
        </div>
        <div>
          <div v-if="title">
            <h6>{{ title }}</h6>
            <v-divider
              v-if="message"
              class="my-4"
              :style="{ borderColor: `var(--v-${messageType}-base)`, opacity: 0.2 }"
            ></v-divider>
          </div>
          <div v-if="message && !isHtml" class="my-2 text-body-2">{{ message }}</div>
          <div v-else-if="message" class="my-2 text-body-2" v-html="message"/>
        </div>
      </div>
    </template>
    <template v-if="!!customEvents" v-slot:action="{ attrs }">
      <div v-bind="attrs">
        <v-divider
          v-if="message"
          class="mb-4"
          :style="{ borderColor: `var(--v-${messageType}-base)`, opacity: 0.2 }"
        ></v-divider>
        <div class="d-flex justify-end">
          <v-btn
            v-if="customEvents.length === 2"
            class="me-2"
            color="grey darken-1"
            depressed
            outlined
            small
            text
            @click="closeMessage"
          >
            {{ customEvents[0].btnTitle }}
          </v-btn>
          <v-btn
            :color="buttonColor"
            depressed
            small
            @click="
              () => {
                closeMessage();
                customEvents[customEvents.length - 1].btnAction();
              }
            "
          >
            {{ customEvents[customEvents.length - 1].btnTitle }}
          </v-btn>
        </div>
      </div>
    </template>
    <template v-else v-slot:action="{ attrs }">
      <v-btn
        v-bind="attrs"
        icon
        style="color: currentColor;"
        @click="() => closeMessage()"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'SystemMessage',
  props: {
		id: String,
    customEvents: {
      type: [Boolean, Array],
      default: false
    },
    isHtml: {
        type: Boolean,
        default: false
    },
    icon: String,
    message: String,
    messageType: {
      type: String,
      default: 'info'
    },
    timeout: {
      type: [Number, String],
      default: 2000
    },
    title: String
  },
  data() {
    return {
      shown: true
    };
  },
  computed: {
    buttonColor() {
      if (this.customEvents[this.customEvents.length - 1]?.btnColor)
        return this.customEvents[this.customEvents.length - 1].btnColor;
      return 'primary';
    },
    iconMap() {
      return {
        info: 'mdi-information-outline',
        success: 'mdi-check-circle-outline',
        warning: 'mdi-alert-outline',
        error: 'mdi-alert-octagon-outline'
      };
    },
    messageIcon() {
      if (this.icon) return this.icon;
      return this.iconMap[this.messageType];
    }
  },
  methods: {
    closeMessage() {
      this.shown = false;
      window.EventBus.$emit('remove-system-message', this.id);
    }
  },
  mounted() {
    if (this.timeout && !this.customEvents.length) {
      setTimeout(() => {
        window.EventBus.$emit('remove-system-message', this.id);
      }, this.timeout);
    }
  }
};
</script>

<style lang="scss">
.v-fade-transition {
  transition-duration: 10000ms !important;
}
</style>
